export enum ClipsEvent {
	MODEL = 'trailer-playing',
}
